import React from 'react';

import linkedIn from 'images/icons/logo-linkedin.svg';
import youtube from 'images/icons/logo-youtube.svg';

const LinksInfo = () => {
  const titles = {
    smTitle: 'Follow Us On Social Media'
  }

  return (
    <div className='mt-5 mx-10 border-t-2 border-gray-300 pt-5'>
      <div className="text-center">
        <div className="text-4xl font-bold pt-3">{titles.smTitle}</div>
      </div>
      <div className='divide-y-4 divide-black mt-5'>

        <div className=' flex items-center justify-center'>
          <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/infocus-connected-solutions/?viewAsMember=true">
          <div className=' border-solid  border-2 text-gray-500 rounded-full h-20 w-20 flex items-center justify-center mr-3'>
            <img className='w-8 h-8' src={linkedIn} alt='linkedin'></img>
          </div>
          </a>

          <a target="_blank" rel="noopener noreferrer" href="https://youtu.be/sJx5zg2fsPE">
            <div className=' border-solid border-2  text-gray-500 rounded-full h-20 w-20 flex items-center justify-center'>
              <img className='w-8 h-8' src={youtube} alt='youtube'></img>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default LinksInfo;